<template>
  <div class="flexing flex-col w-full">
    <div class="w-full p-6 space-y-6">
      <h1 class="text-texts-standard-danger font-medium text-36">
        {{ $t('homepage.emailAlreadySent') }}
      </h1>
      <p class="text-texts-standard-default text-28 font-medium py-8">
        {{
          $replacePlaceholder(
            $t('homepage.password_reset_request_too_frequent'),
            '%s',
            CONNECT_ACCOUNT_TRESHOLD,
          )
        }}
      </p>
      <app-button type="submit" btn-type="confirm" @click="$emit('back')">
        {{ $t('homepage.back') }}
        <component-loading class="absolute inset-0" :is-loading="isLoading" />
      </app-button>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentLoading from '../GlobalComponents/ComponentLoading.vue'
import { defineComponent } from 'vue'
import { CONNECT_ACCOUNT_TRESHOLD } from '@/data/login/constants'

interface ComponentData {
  CONNECT_ACCOUNT_TRESHOLD: typeof CONNECT_ACCOUNT_TRESHOLD
}

export default defineComponent({
  components: {
    ComponentLoading,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['back'],
  data(): ComponentData {
    return {
      CONNECT_ACCOUNT_TRESHOLD,
    }
  },
})
</script>
